import { Component, OnInit, inject } from '@angular/core';
import { SidebarService } from '../../services';
import { Router } from '@angular/router';
import { AppStateHolder } from '../../shared';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { DebugLoggerService } from '../../services/debug-logger.service';

@Component({
    selector: 'sidebar-mobile',
    templateUrl: './sidebar-mobile.component.html',
    styleUrls: ['./sidebar-mobile.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, AsyncPipe]
})
export class SidebarMobileComponent implements OnInit {
  sidebarSrv = inject(SidebarService);
  private _route = inject(Router);
  appStateHolder = inject(AppStateHolder);
  private _debugLogger = inject(DebugLoggerService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  public ngOnInit(): void {
    this._debugLogger.logLifecycle('SidebarMobile', 'ngOnInit');
  }

  public backdrop(): void {
    this.sidebarSrv.setToggleMobile(false);
  }

  public closeSidebar(): void {
    this._debugLogger.logAction('SidebarMobile', 'close');
    this.sidebarSrv.setToggleMobile(false);
  }

  public goBack(): void {
    this.sidebarSrv.goBack();
    this.closeSidebar();
  }

  public goTo(link): void {
    this._debugLogger.logNavigation(link);
    this._route.navigate([link]);
    this.closeSidebar();
  }
}
